import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { submitEnquiry, enquirySource } from "@/lib/docstate";

export const EnquiryForm = ({ kind = "general", subject = "", heading = "Send an enquiry", compact = false, page = "" }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) return toast.error("Please add your name and phone number.");
    setSending(true);
    try {
      await submitEnquiry({ ...form, kind, subject, page: page || window.location.pathname, source: enquirySource() });
      setDone(true);
      toast.success("Thank you — an advisor will be in touch shortly.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (done)
    return (
      <div className="ds-card p-8 text-center" data-testid="enquiry-success">
        <CheckCircle2 className="mx-auto h-10 w-10 text-[#C9A24B]" />
        <p className="ds-display mt-3 text-xl text-[#F3E5AB]">Enquiry received</p>
        <p className="mt-2 text-sm font-light text-[#9D8D83]">Our team will contact you within one business hour.</p>
      </div>
    );

  return (
    <form onSubmit={submit} className="ds-card p-6 sm:p-8" data-testid="enquiry-form">
      {heading && <h3 className="ds-display text-xl text-white">{heading}</h3>}
      <div className={`mt-5 grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`}>
        <input value={form.name} onChange={set("name")} placeholder="Full name" className="ds-input" data-testid="enquiry-name" />
        <input value={form.phone} onChange={set("phone")} placeholder="Phone" className="ds-input" data-testid="enquiry-phone" />
        <input value={form.email} onChange={set("email")} placeholder="Email (optional)" className={`ds-input ${compact ? "" : "sm:col-span-2"}`} data-testid="enquiry-email" />
        <textarea value={form.message} onChange={set("message")} rows={4} placeholder="How can we help?" className={`ds-input resize-none ${compact ? "" : "sm:col-span-2"}`} data-testid="enquiry-message" />
      </div>
      <button type="submit" disabled={sending} className="ds-gold-btn mt-5 w-full px-6 py-3 text-sm disabled:opacity-60" data-testid="enquiry-submit">
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}{sending ? "Sending..." : "Submit Enquiry"}
      </button>
    </form>
  );
};
